import alert from '@/plugins/alert'
import { AssetTransaction } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    count: 0,
    pageText: '',
    itemsPerPage: 10,
    transactionSearchParams: {},
    totalItems: 0,
    transactions: []
  },
  actions: {
    async searchTransactionList({ commit, state, dispatch }, query) {
      const transactionSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { transactionSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.transactionSearchParams) {
        const transactionSearchParams = {
          ...state.transactionSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }

        const [totalItems, transactions] = await Promise.all([
          AssetTransaction.count(transactionSearchParams),
          AssetTransaction.search(transactionSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            transactions,
            totalItems,
            itemsPerPage,
            transactionSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async createTransaction({ commit, state }, payload) {
      try {
        const created = await AssetTransaction.create(payload)
        commit('changeState', {
          transactions: [created, ...state.transactions]
        })
        alert.success('Tạo phiếu thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async removeTransaction({ commit }, id) {
      try {
        await AssetTransaction.remove(id)
        commit('removeTransaction', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    removeTransaction(state, id) {
      state.transactions = state.transactions.filter(t => t.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  }
}
